<template>
  <a-cascader 
    :options="list"
    :load-data="loadData"
    @change="onChange"
    change-on-select
    :placeholder='placeholder'
    v-model="arr"
    />
</template>

<script>

export default {
  props:['value','category'],
  data(){
    return {
      list:[],
      arr: []
    }
  },
  watch: {
    value:{
      handler(val){
        this.arr = val
      },
      deep: true
    }
  },
  computed:{
    placeholder(){
      return this.category === 'raw' ? '选择原料类型' : '选择营养指标类型'
    }
  },
  async mounted(){
    // const res = await this.$get('/nhf-core-data/basictype/listByParentId', { category:this.category, parentId:0})
     // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
    const res = await this.$get('/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit', { category:this.category, parentId:0,deptId})
    this.list = res.data.map(this.mapFilter)
  },

  methods: {
    onChange(val,selected){
      this.selected = val
      this.$emit('changeVal',val)
      this.$emit('change', [...val].pop())
      this.$emit('select', selected)
    },

    mapFilter (i) {
      return {
        ...i,
        label:i.name,
        value:i.id,
        isLeaf: !i.hasChildren
      } 
    },

    async loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      const {value:parentId} = targetOption
      // const res = await this.$get('/nhf-core-data/basictype/listByParentId', { category:this.category, parentId})
       // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail
      const res = await this.$get('/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit', { category:this.category, parentId,deptId})
      targetOption.loading = false
      targetOption.children = res.data.map(this.mapFilter)
      this.list = [...this.list]
    },
  }

}
</script>